import React, { useState } from 'react';

const ClocheMenu = ({ onNavigate }) => {
  const [isOpen, setIsOpen] = useState(false);

  const menuItems = [
    { id: 'meal-plan', label: 'Meal Plan', icon: '🍽️', comingSoon: true },
    { id: 'cookbook', label: 'Recipe Book', icon: '📚', comingSoon: false, action: 'recipes' },
    { id: 'chat', label: 'Chat', icon: '💬', comingSoon: true },
    { id: 'shared-lists', label: 'Shared Lists', icon: '👥', comingSoon: true }
  ];

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  const handleMenuItemClick = (item) => {
    if (item.comingSoon) {
      // Could add a toast notification here
      console.log(`${item.label} coming soon!`);
    } else if (item.action && onNavigate) {
      onNavigate(item.action);
    }
    setIsOpen(false);
  };

  return (
    <div className="relative">
      {/* Cloche Container */}
      <div className="flex justify-center mt-8 mb-4">
        <div 
          className="relative cursor-pointer group"
          onClick={toggleMenu}
        >
          {/* Cloche Dome - More realistic shape */}
          <div className="relative w-32 h-20">
            {/* Main cloche dome */}
            <div className="absolute inset-0 bg-gradient-to-b from-gray-100 via-gray-200 to-gray-300 rounded-t-full shadow-2xl border-2 border-gray-400 group-hover:shadow-3xl transition-all duration-500 group-hover:scale-105">
              {/* Metallic shine effect */}
              <div className="absolute top-2 left-3 right-3 h-12 bg-gradient-to-b from-white/50 via-white/25 to-transparent rounded-t-full"></div>
              
              {/* Hamburger Lines - More refined */}
              <div className="absolute inset-0 flex flex-col items-center justify-center space-y-1.5">
                <div className="w-8 h-0.5 bg-gray-700 rounded-full transition-all duration-300 group-hover:bg-gray-900"></div>
                <div className="w-8 h-0.5 bg-gray-700 rounded-full transition-all duration-300 group-hover:bg-gray-900"></div>
                <div className="w-8 h-0.5 bg-gray-700 rounded-full transition-all duration-300 group-hover:bg-gray-900"></div>
              </div>
              
              {/* Rim highlight */}
              <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-white/70 to-transparent rounded-t-full"></div>
            </div>
            
            {/* Cloche handle/knob */}
            <div className="absolute -top-3 left-1/2 transform -translate-x-1/2 w-4 h-4 bg-gradient-to-b from-gray-200 to-gray-400 rounded-full shadow-lg border border-gray-500"></div>
            
            {/* Base plate */}
            <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 w-36 h-3 bg-gradient-to-b from-gray-200 to-gray-400 rounded-full shadow-lg border border-gray-500"></div>
          </div>
        </div>
      </div>

      {/* Dropdown Menu - Receipt printing from cloche base */}
      <div className="absolute left-1/2 transform -translate-x-1/2 w-64 z-50" style={{ top: '100%' }}>
        {/* Each menu item as individual receipt strips */}
        {menuItems.map((item, index) => (
          <div
            key={item.id}
            className={`absolute left-0 w-full bg-white border-l border-r border-gray-300 ${
              index === 0 ? 'rounded-t-xl border-t' : ''
            } ${
              index === menuItems.length - 1 ? 'rounded-b-xl border-b' : ''
            } ${
              isOpen 
                ? 'opacity-100 translate-y-0' 
                : 'opacity-0 translate-y-full pointer-events-none'
            }`}
            style={{
              top: `${index * 60}px`, // Stack each item 60px below the previous
              transition: 'all 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
              transitionDelay: isOpen ? `${index * 0.2}s` : '0s',
              zIndex: menuItems.length - index, // Higher z-index for items that appear first
              transformOrigin: 'top center'
            }}
          >
            {/* Clean thin line separator (except for first item) */}
            {index > 0 && (
              <div className="absolute top-0 left-0 right-0 h-px bg-gray-200"></div>
            )}
            
            <button
              onClick={() => handleMenuItemClick(item)}
              className="w-full flex items-center justify-between px-6 py-4 text-left hover:bg-gray-50 transition-colors duration-200 group"
            >
              <div className="flex items-center space-x-4">
                <span className="text-2xl">{item.icon}</span>
                <div>
                  <span className="font-medium text-gray-800 group-hover:text-purple-600 transition-colors">
                    {item.label}
                  </span>
                  {item.comingSoon && (
                    <div className="text-xs text-gray-500">Coming soon</div>
                  )}
                </div>
              </div>
              
              {item.comingSoon ? (
                <span className="text-xs bg-gray-100 text-gray-600 px-2 py-1 rounded-full">
                  Soon
                </span>
              ) : (
                <svg 
                  className="w-4 h-4 text-gray-400 group-hover:text-purple-500 transition-colors" 
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
                </svg>
              )}
            </button>
          </div>
        ))}
      </div>

      {/* Backdrop for mobile */}
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black/20 backdrop-blur-sm z-40 md:hidden"
          onClick={() => setIsOpen(false)}
        />
      )}
    </div>
  );
};

export default ClocheMenu;
